import React, { ClassAttributes, HTMLAttributes, forwardRef } from "react";

import "./modal.css";

export interface ModalContentUIProps {}

export type ModalContentProps = HTMLAttributes<HTMLElement> &
    ModalContentUIProps &
    ClassAttributes<HTMLElement>;

const ModalContent = forwardRef<HTMLElement, ModalContentProps>((props, ref) => {
    const { className, children, ...rest } = props;

    const classes = ["modal-content", className].filter(Boolean).join(" ");

    return (
        <section
            {...rest}
            ref={ref as any}
            className={classes}
        >
            {children}
        </section>
    );
});

ModalContent.displayName = "ModalContent";

export default ModalContent;
